import CloseIcon from '@mui/icons-material/Close';
import { Divider, IconButton, Popover, Stack, Typography, useTheme } from '@mui/material';
import { Door } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { getLockIcon } from 'utils/Lock/Lock';

interface Props {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  deviceGroupName: string;
  devices: Door[];
}

const POPOVER_WIDTH = 400;
const POPOVER_MAX_HEIGHT = 400;

const DeviceGroupDevicesPopover: React.FC<Props> = ({ anchorEl, open, onClose, deviceGroupName, devices }) => {
  const { translation } = useTranslation();
  const theme = useTheme();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Stack sx={{ width: POPOVER_WIDTH, maxWidth: '90vw' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ pl: 2, pr: 1, py: 1 }}>
          <Typography variant="subtitle1">{deviceGroupName}</Typography>
          <IconButton
            id="device-group-devices-popover-close-button"
            onClick={onClose}
            size="small"
            aria-label={translation.close}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
        <Divider />
        <Stack sx={{ p: 2, gap: 1, maxHeight: POPOVER_MAX_HEIGHT, overflowY: 'auto' }}>
          <Stack direction="row" alignItems="baseline" spacing={0.5}>
            <Typography variant="subtitle2">{translation.devices}</Typography>
            <Typography variant="caption" color="textSecondary">
              {devices.length}
            </Typography>
          </Stack>
          {devices.map((device) => (
            <Stack
              key={device.id}
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ backgroundColor: theme.custom.background.level2, borderRadius: 1, p: 1.5 }}
            >
              {getLockIcon(device, { color: 'action', sx: { flexShrink: 0 } })}
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                {device.name}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Popover>
  );
};

export default DeviceGroupDevicesPopover;
